import * as React from 'react';
import {useSelector} from 'react-redux';

import {AddablePeople} from 'shells/visitor-sidebar/visitor-content/company-people/addable-people';

import {useAddPdlContactsToAccount} from '../../../people-iq/graphql/hooks/use-add-pdl-contacts-to-account';
import {getAgentEntityContext} from '../../../team-ai/redux/agent-selectors';

import {analyticsClient} from '../../../../analytics-client';

import {InteractionModalFooter} from '../interaction-modal-footer';
import type {FindPotentialContactsData} from '../types';

import styles from './../interaction-modal.module.css';

type Props = {
    data: FindPotentialContactsData;
    onCancel: () => void;
};

export function FindPotentialContactsPage(props: Props) {
    const [selectedPersonIds, setSelectedPersonIds] = React.useState<string[]>([]);

    // @ts-expect-error
    const {entityId: leadId} = useSelector(getAgentEntityContext);

    const {addContacts, isAdding} = useAddPdlContactsToAccount();

    const handleUpdateSelectedPersonIds = (personId: string) => {
        setSelectedPersonIds(
            selectedPersonIds.includes(personId)
                ? selectedPersonIds.filter((id) => id !== personId)
                : [...selectedPersonIds, personId]
        );
    };

    const onAddContacts = () => {
        addContacts({
            pdlContactIds: selectedPersonIds,
            accountId: props.data.accountId,
            leadId,
        }).then(() => {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_AI_ASSISTANT_LEAD_PEOPLE_ADDED);
            $('body').trigger(Nut.events.global.accountContactsWereUpdated);
            props.onCancel();
        });
    };

    const addablePeople = props.data.potentialContacts.map((contact) => ({
        id: contact.id,
        name: contact.fullName,
        location: contact.location,
        jobTitle: contact.jobTitle,
        position: contact.position,
        hasEmail: contact.hasEmail,
        hasPhone: contact.hasPhone,
        hasLinkedinUrl: contact.hasLinkedinUrl,
    }));

    return (
        <>
            <div className={styles['find-potential-contacts-execute-page-container']}>
                <AddablePeople
                    people={addablePeople}
                    selectedPersonIds={selectedPersonIds}
                    updateSelectedPersonIds={handleUpdateSelectedPersonIds}
                    onClose={() => {}}
                />
            </div>
            <InteractionModalFooter
                onCancel={props.onCancel}
                onContinue={onAddContacts}
                primaryButtonText='Add contacts'
                primaryButtonLoading={isAdding}
                primaryButtonDisabled={selectedPersonIds.length === 0}
            />
        </>
    );
}
